import controller from './template-detail.controller';
import template from './template-detail.html';

const component = {
    controller,
    template,
    bindings: {
        template: '<',
        isNew: '<',
        organizationId: '<',
        contactGroups: '<',
        contactGroupInfo: '<',
        escalationTemplates: '<',
        onCreate: '&',
        onUpdate: '&',
        onDelete: '&',
        onCancel: '&'
    }
};

export default component; 